var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.field.componentName,{tag:"component",attrs:{"field":_vm.field,"value":_vm.field.value,"readonly":_vm.readonly,"outlined":_vm.field.outlined,"validations":_vm.validations},on:{"fieldChange":function($event){return _vm.$emit('fieldChange', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }